import { PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

import { CountryCode } from './countries';
import { getCountryInfoFromCountryCode } from './countryUtils/getCountryInfo';
import { getPhoneUtil } from './getPhoneUtil';

const hasCountryCodeInPhoneNumber = (phoneNumber: string) =>
  phoneNumber.trim().startsWith('+');

type GeneratePhoneInfoReturn = {
  phoneString: string;
  phone: PhoneNumber | null;
};

const pnu = getPhoneUtil();

/**
 * @desciption generates full phone number from phone input and countryCode
 */
export const generatePhoneInfo = (
  phoneNumber: string,
  countryCode: CountryCode
): GeneratePhoneInfoReturn => {
  // remove any non-numeric characters
  const normalizedNumber = phoneNumber.trim().replace(/(?!^\+)[\D+]/g, '');
  const { dialingCode } = getCountryInfoFromCountryCode(countryCode);

  const hasUserTypedCountryCode = hasCountryCodeInPhoneNumber(phoneNumber);
  const hasLeadingZeroes = normalizedNumber.startsWith('0');

  if (hasUserTypedCountryCode) {
    try {
      const phone = pnu.parse(normalizedNumber);
      const phoneString = pnu.format(phone, PhoneNumberFormat.E164);
      return { phoneString, phone };
    } catch {
      return { phoneString: normalizedNumber, phone: null };
    }
  }

  if (hasLeadingZeroes) {
    try {
      const phone = pnu.parse(normalizedNumber, countryCode);
      const phoneString = pnu.format(phone, PhoneNumberFormat.E164);
      return { phoneString, phone };
    } catch {
      return { phoneString: normalizedNumber, phone: null };
    }
  }

  try {
    const internationalisedNumber = `${dialingCode}${normalizedNumber}`;
    const phone = pnu.parse(internationalisedNumber, countryCode);
    const phoneString = pnu.format(phone, PhoneNumberFormat.E164);
    return { phoneString, phone };
  } catch {
    return { phoneString: normalizedNumber, phone: null };
  }
};
